import React from 'react';
import { connect } from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';

import { RootState } from '../../store';
import FlagNotesInfo from '../Tools/FlagNotesInfo';

type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps;

function FlagNotes({ activePdf }: Props) {
  if (activePdf == null || activePdf.riskIncreaseReasons == null || activePdf.riskIncreaseReasons.length === 0) {
    return null;
  }

  return (
    <Box sx={{ maxWidth: 360, 'z-index': 1, m: 'auto', my: 3 }}>
      <Accordion sx={{ bgcolor: 'backContrast.main' }} defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Flag Reasons</Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            maxHeight: 150,
            overflowX: 'hidden',
            overflowY: 'hidden',
            '&:hover': {
              overflowY: 'auto',
            },
            bgcolor: 'backContrast.main',
          }}
        >
          <FlagNotesInfo pdfName={activePdf.name} riskIncreaseReasons={activePdf.riskIncreaseReasons} />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}

function mapStateToProps(state: RootState) {
  return {
    activePdf: state.documents.pdfData[state.documents.activeDocumentId!],
  };
}

export default connect(mapStateToProps)(FlagNotes);
